import React from "react";
import { Link } from "react-router-dom";
import "../styles/Dashboard.css"

const LandingPage = () => {
  return (
    <div  className="landing-container landing-login" >
      <div className="logo-container">
           <img src="/images/mainLogo.png" alt="Logo" className="mian-logo"/>
      </div>

      <div className="text-center first-button1" >
        <Link
          to="/login"
          className="btn custom-btn"
        >
          LOGIN
        </Link>

        <Link
          to="/signup"
          className="btn custom-btn"
        >
          SIGN UP
        </Link>
      </div>
    </div>
  );
};

export default LandingPage;
